var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper"},[_vm._l((_vm.steps),function(step,i){return _c('div',{key:i,staticClass:"stepper__step",class:{
      'stepper__step--done': step.done,
      'stepper__step--error': step.error,
      'stepper__step--selected': step.selected
    },on:{"click":() => _vm.$emit('click', step.id)}},[_c('div',{staticClass:"stepper__step__number"},[_c('strong',[_vm._v(_vm._s(i + 1))])]),_vm._v(" "+_vm._s(step.title)+" ")])}),_c('div',{staticClass:"stepper__line"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }